import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/app/layouts/blank.vue").then(m => m.default || m)),
  "default-max-screen": defineAsyncComponent(() => import("/app/layouts/default-max-screen.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  "minimal-dark": defineAsyncComponent(() => import("/app/layouts/minimal-dark.vue").then(m => m.default || m)),
  minimal: defineAsyncComponent(() => import("/app/layouts/minimal.vue").then(m => m.default || m)),
  partner: defineAsyncComponent(() => import("/app/layouts/partner.vue").then(m => m.default || m))
}